import React from 'react';
import { Avatar } from 'antd';

const UserProfileImage = ({ user, className }) => {
  return <Avatar className={className} src={user?.profileImageUrl} />;
};

export default UserProfileImage;
